import { useApiClient } from '@m43/core';
import { useCallback } from 'react';
import {
    AttributeOption,
    HospitalsResource,
    HospitalStatusContextMenuItemView,
} from '@mark43/cad-api';
import {
    ContextMenuSub,
    ContextMenuSubContent,
    ContextMenuSubTrigger,
    ContextMenuItem,
} from '@cad-arc';

export function HospitalStatusSubmenu({
    hospitalId,
    hospitalStatusContextMenuItemView,
}: {
    hospitalId: number;
    hospitalStatusContextMenuItemView: HospitalStatusContextMenuItemView;
}) {
    const apiClient = useApiClient();
    const { isVisible, statusOptions, label } = hospitalStatusContextMenuItemView;
    const setHospitalStatus = useCallback(
        (hospitalStatusAttributeOption: AttributeOption) => {
            return apiClient.request<HospitalsResource.EditHospitalStatus>({
                method: 'POST',
                url: 'hospitals/status',
                data: {
                    hospitalId,
                    hospitalStatusAttributeOption,
                },
            });
        },
        [apiClient, hospitalId]
    );

    if (isVisible) {
        return (
            <ContextMenuSub>
                <ContextMenuSubTrigger>{label}</ContextMenuSubTrigger>
                <ContextMenuSubContent>
                    {statusOptions.map((hospitalState) => (
                        <ContextMenuItem
                            key={hospitalState.value}
                            onSelect={() => {
                                setHospitalStatus(hospitalState);
                            }}
                        >
                            {hospitalState.label}
                        </ContextMenuItem>
                    ))}
                </ContextMenuSubContent>
            </ContextMenuSub>
        );
    }

    return <></>;
}
